import {
  fileCertificate,
  screwdriverWrench,
  shield,
  shieldCheck,
  users,
  type IconDefinition,
  type IconName,
} from "@simplybusiness/icons";

/**
 * Map of icon names to icon definitions used in CoverageSuggestions stories.
 * Only import the icons that are actually used to reduce bundle size.
 */
export const coverageSuggestionIconMap: Record<IconName, IconDefinition> = {
  fileCertificate,
  screwdriverWrench,
  shield,
  shieldCheck,
  users,
} as Record<IconName, IconDefinition>;
